import { render, staticRenderFns } from "./userCenter.vue?vue&type=template&id=43956b2e&scoped=true"
import script from "./userCenter.vue?vue&type=script&lang=js"
export * from "./userCenter.vue?vue&type=script&lang=js"
import style0 from "./userCenter.vue?vue&type=style&index=0&id=43956b2e&prod&lang=css"
import style1 from "./userCenter.vue?vue&type=style&index=1&id=43956b2e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43956b2e",
  null
  
)

export default component.exports